import { ListingSearch } from "../dto/listing/ListingSearch";
import Axios, { AxiosRequestConfig } from 'axios';
import {
    URL_BACKEND_ROOT
} from "../app/AppConst";
import { BaseResponse } from '../dto/response/BaseResponse';
import { ReadResponse } from '../dto/response/ReadResponse';
import { ApiClient } from "../util/ApiUtility";
import { ListingDetailEntity } from "../dto/listing/ListingDetailEntity";
import { BidSearch } from "../dto/bid/BidSearch";
import { OfferSearch } from "../dto/offer/OfferSearch";

export const onListingSearch = async (data: ListingSearch) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
        'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/listing/search',
        params: {
          categoryIds: data.categoryIds && data.categoryIds.length > 0 ? data.categoryIds.join(',') : null,
          brandIds: data.brandIds && data.brandIds.length > 0 ? data.brandIds.join(',') : null,
          phoneNo: data.phoneNo,
          nickname: data.nickname,
          offset: data.offset,
          limit: data.limit
      }
    }
  
    const response = await ApiClient().request<ReadResponse>(requestConfig);
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}

export const onListingDetail = async (id: number) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
        'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/listing/' + id
    }
    const response = await ApiClient().request<BaseResponse<ListingDetailEntity>>(requestConfig);

    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}

export const onBidSearch = async (data: BidSearch) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
        'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/listing/bid/search',
        params: {
          listingId: data.listingId,
          phoneNo: data.phoneNo,
          nickname: data.nickname,
          offset: data.offset,
          limit: data.limit
      }
    }
  
    const response = await ApiClient().request<ReadResponse>(requestConfig);
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}
 
export const onOfferSearch = async (data: OfferSearch) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
        'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/listing/offer/search',
        params: {
          listingId: data.listingId,
          phoneNo: data.phoneNo,
          nickname: data.nickname,
          offset: data.offset,
          limit: data.limit
      }
    }
  
    const response = await ApiClient().request<ReadResponse>(requestConfig);
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}

const post = async (url: string, data: object) => {
    const requestConfig: AxiosRequestConfig = {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        url: `${URL_BACKEND_ROOT}${url}`,
        data
    };
    const response = await ApiClient().request<BaseResponse<any>>(requestConfig);
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    }
    throw new Error("Амжилтгүй");
};
 
// ACTIVE → SUSPENDED
export const suspendListing = (listingId: number, reason: string) =>
    post('/v1/cms/listing/suspend', { listingId: String(listingId), reason });
 
// SUSPENDED → CANCELLED  (+refund winningBidId holder)
export const cancelListing = (listingId: number, reason: string) =>
    post('/v1/cms/listing/cancel', { listingId: String(listingId), reason });
 
// SUSPENDED → ACTIVE
export const restoreListing = (listingId: number, reason: string) =>
    post('/v1/cms/listing/restore', { listingId: String(listingId), reason });
 
// ENDED → manual payout to seller
export const manualPayout = (listingId: number) =>
    post('/v1/cms/listing/payout', { listingId: String(listingId) });